var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.3027,
    cy: 44.3027,
    r: 44.3027,
    fill: "#3A6A7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9921 63.1686L27.9111 58.8963L41.7813 37.0735L65.8632 41.3461L51.9921 63.1686Z",
    stroke: "#FFFDF4",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1611 28.6252L47.5498 53.1857L20.2737 48.3465L35.885 23.7859L63.1611 28.6252Z",
    fill: "#FFFDF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempIcon);
export default __webpack_public_path__ + "static/media/temp_icon.43811863d2ea80c5e090a964188f4851.svg";
export { ForwardRef as ReactComponent };